import { FaFacebook, FaWhatsapp,FaTwitter,FaLinkedin,FaYoutube, FaPhone, FaInstagram, FaGithub } from "react-icons/fa";
import { AiOutlineMail } from "react-icons/ai";
import myImage from "../../image/udoka.png"
import Aos from "../aos/aos";
import HeroImg from "../home/hero/image";
const ContactHero = () => {
    Aos(2000)
    return (
        <div className="flex flex-col md:flex-row space-y-4 justify-center items-center  bg-black/30 rounded-lg md:space-x-8 md:space-y-0 w-full h-[600px]  md:h-[550px]">

            <div data-aos="fade-in" className=" md:h-full md:ml-8 h-[40%] flex flex-col text-white items-center justify-center space-y-8 w-full md:w-[50%] py-2 px-2">

                <div className=" font-extrabold text-2xl md:text-4xl font-mono text-yellow-500">Reach Me On</div>
                <div className="grid grid-cols-4 gap-y-8  w-full place-items-center place-content-center">
                    <a data-aos="fade-down" href="tel:+2348165459380"><FaPhone size={30} /></a>
                    <a data-aos="flip-up" href="https://wa.me/+2348165459380"><FaWhatsapp size={30} /></a>
                    <a data-aos="fade-up" href="https://www.facebook.com/profile.php?id=100068156498882"><FaFacebook size={30} /></a>
                    <a data-aos="fade-down" href="https://linkedin.com/in/udoka-otsu-526a02265"><FaLinkedin size={30} /></a>
                    <a data-aos="flip-up" href="www.instagram.com/otsu_udoka"><FaInstagram size={30} /></a>
                    <a data-aos="fade-up" href="www.twitter.com/otsu_udoka"><FaTwitter size={30} /></a>
                    <a data-aos="fade-down" href="https://github.com/udoka4397"><FaGithub size={30} /></a>
                    <a data-aos="flip-up" href="www.youtube.com/udokaotsu1122"><FaYoutube size={30} /></a>
                    <a data-aos="fade-up" href="mailto:otsuudoka@gmail.com"><AiOutlineMail size={30} /></a>
                </div>

            </div>
            <HeroImg/>



        </div>
    );
}

export default ContactHero;